// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { Component } from "react";
import {
  TextField,
  DefaultButton,
  PrimaryButton,
  FocusZone,
  FocusZoneTabbableElements
} from "office-ui-fabric-react";

import ModalComponent from "../../ModalComponent/ModalComponent";
import { ModelService } from "../../../services/ModelService";
import { apiService } from "../../../services/ApiService";
import { print } from "../../../services/LoggingService";
import { eventService } from "../../../services/EventService";

import "./ModelViewerCreateComponent.scss";

export class ModelViewerCreateComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isLoading: false,
      name: "",
      payload: "",
      error: "",
      item: null
    };
  }

  open(item) {
    this.setState({
      item,
      showModal: true,
      name: "",
      payload: "",
      error: ""
    });
  }

  cancel = e => {
    e.preventDefault();
    this.setState({ showModal: false });
  };

  onNameChange = evt => {
    this.setState({ name: evt.target.value });
  };

  onPayloadChange = evt => {
    this.setState({ payload: evt.target.value });
  };

  getStyles = () => ({
    fieldGroup: [{ height: "32px" }]
  });

  save = async e => {
    e.preventDefault();

    const { name, payload, item } = this.state;

    if (!name) {
      this.setState({ error: "Please enter a twin name." });
      return;
    }

    if (!payload || !payload.trim()) {
      this.setState({ error: "Please enter payload data." });
      return;
    }

    let payloadParsed;
    try {
      payloadParsed = JSON.parse(payload);
    } catch (err) {
      this.setState({ error: "Invalid payload data. Must be valid JSON." });
      return;
    }

    // Enforce required Digital Twins fields
    payloadParsed.$dtId = name;

    payloadParsed.$metadata = payloadParsed.$metadata || {};
    payloadParsed.$metadata.$model = item.key;

    this.setState({ isLoading: true, error: "" });

    try {
      const twinResult = await apiService.addTwin(name, payloadParsed);

      eventService.publishCreateTwin({
        $dtId: name,
        $metadata: { $model: item.key }
      });

      eventService.publishSelection();
    } catch (exc) {
      exc.customMessage = "Error in instance creation";
      eventService.publishError(exc);
    }

    this.setState({ showModal: false, isLoading: false });
  };

  render() {
    const { showModal, name, error, isLoading, payload } = this.state;

    return (
      <ModalComponent
        isVisible={showModal}
        isLoading={isLoading}
        className="mv-create"
      >
        <FocusZone
          handleTabKey={FocusZoneTabbableElements.all}
          isCircularNavigation
          defaultActiveElement="#outlined-required"
        >
          <form onSubmit={this.save}>
            <h2 className="heading-2">
              {this.props.t("modelViewerCreateComponent.heading")}
            </h2>

            <TextField
              required
              errorMessage={error}
              id="outlined-required"
              className="name-input"
              styles={this.getStyles}
              value={name}
              onChange={this.onNameChange}
              autoFocus
              ariaLabel={this.props.t(
                "modelViewerCreateComponent.heading"
              )}
            />

            <TextField
              required
              multiline
              rows={8}
              label="Twin Payload (JSON)"
              value={payload}
              onChange={this.onPayloadChange}
            />

            <div className="btn-group">
              <PrimaryButton
                type="submit"
                className="modal-button save-button"
                onClick={this.save}
              >
                {this.props.t("modelViewerCreateComponent.saveButton")}
              </PrimaryButton>

              <DefaultButton
                className="modal-button cancel-button"
                onClick={this.cancel}
              >
                {this.props.t("modelViewerCreateComponent.cancelButton")}
              </DefaultButton>
            </div>
          </form>
        </FocusZone>
      </ModalComponent>
    );
  }
}
